import * as queryString from "querystring";
import React, { useContext, useEffect, useState } from "react";
import { GoogleReCaptcha, GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useNavigate, useLocation } from "react-router-dom";
import ILoadUserDTO from "../../../models/DTO/ILoadUserDTO";
import IOnLoginDTO from "../../../models/DTO/IOnLoginDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import INotification from "../../../models/INotification";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import SocketService from "../../../services/SocketService";
import OwButton from "../../shared/OwButton/OwButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import { SocketContext } from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import ky from "ky";

type Props = {};

const Login = (props: Props) => {
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const history = useNavigate();
    const location = useLocation();

    const recaptchaSiteKey = "6LeVqCQTAAAAAFa7Nx1qUX8HDlW1plLraLyu7xk0";

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [recaptcha, setRecaptcha] = useState("");
    const [loginBtnActive, setLoginBtnActive] = useState(false);

    const loadUser = (userGuid: string, userToken: string) => {
        const payload: ILoadUserDTO = {
            userGuid,
            userToken,
        };

        socket.emit(EndpointsEnum.AppLoadUser, payload);

        // the expectation is that onLoadUser the App.tsx will navigate the user to the right location.
    };

    const notify = () => {
        setLoginBtnActive(false);
    };

    const performAutoLogin = () => {
        const params = queryString.parse(location.search);

        if (Object.keys(params).length) {
            const guid: string = params.guid as string;
            const token: string = params.token as string;

            if (guid && token) {
                loadUser(guid, token);

                uiContext.setActivityIndicator(true);
            } else {
                uiContext.setActivityIndicator(false);
            }
        } else {
            uiContext.setActivityIndicator(false);
        }
    };

    const sockets: IUiSocketSetup[] = [
        // { endpoint: EndpointsEnum.AppOnLoadUser, fn: onLoadUser }
        { endpoint: EndpointsEnum.Notify, fn: notify },
    ];

    useEffect(() => {
        if (uiContext.setActivityIndicator) {
            uiContext.setActivityIndicator(false);
        }

        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        document.title = `Orderwerks >> Login`;

        // console.log("Search: ", location.search);

        performAutoLogin();

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const handleChange = (e: any) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        switch (name) {
            case "email":
                setEmail(value);
                break;
            case "password":
                setPassword(value);
                break;
            default:
                break;
        }
    };

    const handleCaptchaChange = (token: string | null) => {
        if (token) {
            setRecaptcha(token);
        }
    };

    const doLogin = () => {
        const apiUrl = SocketService.getAuthUrl();

        const payload = {
            email,
            password,
            recaptcha,
        };

        const url = `${apiUrl}/login`;

        ky.post<IOnLoginDTO>(url, {
            json: payload,
        }).then(
            async (res) => {
                // console.log("doLogin Response: ", res);
                // UserService.saveUserData(res.data);
                const data = await res.json();

                console.log("ky login: ", data);

                loadUser(data.guid, data.token);
            },
            (err) => {
                setLoginBtnActive(false);

                const notification: INotification = {
                    title: "error_logging_in",
                    level: NotificationLevelEnum.error,
                    position: NotificationPositionEnum.br,
                };

                uiContext.notifyFn(null, notification, false);
            }
        );

        setLoginBtnActive(true);
    };

    return (
        <GoogleReCaptchaProvider reCaptchaKey={"6LdE_XUmAAAAAOiZdqLL2Au7G2tBDI3hoygdqfH_"}>
            <div className={"col-12 col-md-4 col-lg-3 offset-md-4 offset-lg-4"}>
                <OwTitle className={"mt-4"} title={"login"} tag={"h2"} />

                <div className={"mt-4"}>
                    <OwLabel title={"email"} />
                    <OwInputWrapper title={"login email"} tabIndex={1} name={"email"} value={email} fn={handleChange} isRequired={true} />
                </div>

                <div className={"mt-4"}>
                    <OwLabel title={"password"} />
                    <OwInputWrapper
                        title={"password"}
                        name={"password"}
                        value={password}
                        fn={handleChange}
                        type={"password"}
                        isRequired={true}
                    />
                </div>

                <div className={"mt-2"}>
                    <GoogleReCaptcha onVerify={setRecaptcha} />
                </div>

                <div className={"mt-2"}>
                    <OwButton fn={doLogin} title={"login"} active={loginBtnActive} disableOnActive={true} />
                </div>
            </div>
        </GoogleReCaptchaProvider>
    );
};

export default Login;
